module.exports = __webpack_public_path__ + "static/media/broken-matzah.f5f3af13.png";